import React from "react"

import Layout from "../../shared-components/layout"
import CatalogHeader from "./catalog-header"
import CatalogPanel from "./catalog-panel"
import { CategoryProps } from "./catalog-panel/types"

function CatalogPageContent({ downloadable, category }: CategoryProps) {
  return (
    <Layout>
      <CatalogHeader showCta />
      <CatalogPanel downloadable={downloadable} category={category} />
    </Layout>
  )
}

export default CatalogPageContent
